import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "assets/scss/dashboard.scss";
import "assets/css/charts_form_controls.css";
import "assets/css/grid_table.css";
import numeral from "numeral";
import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import Select from "react-select";
import { Divider } from "primereact/divider";
import moment from "moment";
import { getDataApi, saveApi, loadApi } from "services/appApi";
import { pecaPageRows, pecaRowsPerPageOptions } from "pages/common/envPECA";
import axios from "axios";

const MgMachine = () => {
  let emptyRow = {
    end_date_active: null,
    machine_group_id: null,
    machine_group_name: "",
    machine_id: null,
    machine_name:"",
    row_id: "",
    sort_key: null,
    start_date_active : ""
  };

  /**** 31-May-2024 Velmani P. Following changes are made to template
   * 	a. Use a generic name "row" instead of "product".  Following are the name changed from template
   * 	   a1. products ==> rows
   * 		[products, setProducts] ==> [products, setRows]
   * 		[deleteProductsDialog, setDeleteProductsDialog] ==> [deleteRowsDialog, setDeleteRowsDialog]
   * 		[selectedProducts, setSelectedProducts] ==> [selectedRows, setSelectedRows]
   * 	   a2. product  ==> row
   *		[productDialog, setProductDialog] ==> [productDialog, setRowDialog]
   *		[deleteProductDialog, setDeleteProductDialog] ==> [deleteRowDialog, setDeleteRowDialog]
   *		[product, setProduct] ==> [product, setRow]
   * ******/
  const [rows, setRows] = useState([]);
  const [rowDialog, setRowDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [deleteRowDialog, setDeleteRowDialog] = useState(false);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [dialog, setDialog] = useState("");
  const [wasDataFetchingSuccessful, setWasDataFetchingSuccessful] = useState(true);
  const [machineId, setMachineId] = useState({label: "", value: null});
  const [machineSelectId, setMachineSelectId] = useState({label: "", value: null});
  const [machineGroupId, setMachineGroupId] = useState({label: "", value: null});
  const [machineGroupSelectId, setMachineGroupSelectId] = useState({label: "", value: null});
  const [sortKey, setSortKey] = useState(null);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [fetchMachine, setFetchMachine] = useState(true);
  const [fetchMachineGroup, setFetchMachineGroup] = useState(true);
  const [machineName, setMachineName] = useState([]);
  const [machineGroup, setMachineGroup] = useState([]);
  const toast = useRef(null);
  const dt = useRef(null);

  useEffect(() => {
        const fetchMachine = async () => {
          setFetchMachine(true);
          try {
            let res = await getDataApi("/api/setup/machineMG/mgMachines/mgMachineLOV");
            if (res) {
              let successFlag = res.data[0];
              console.log("Response: ",res);
              console.log("Success Flag",successFlag);
              if (successFlag === "Y" && Array.isArray(res.data[1])) {
                const options= res.data[1].map((item)=>({
                  label: item.machine_name,
                  value: item.machine_id
                }))
                setMachineName(options)
                setFetchMachine(false);
              } 
            }
          } catch (err) {
            console.log(err);
            setFetchMachine(false);
          }
        };
        fetchMachine();
      }, []);

      useEffect(() => {
        const fetchMachineGroup = async () => {
          setFetchMachineGroup(true);
          try {
            let res = await getDataApi("/api/setup/machineMG/mgMachines/mgMachineGrpLOV");
            if (res) {
              let successFlag = res.data[0];
              console.log("Machine Group Response: ",res);
              console.log("Success Flag",successFlag);
              if (successFlag === "Y" && Array.isArray(res.data[1])) {
                const options= res.data[1].map((item)=>({
                  label: item.machine_group_name,
                  value: item.machine_group_id
                }))
                setMachineGroup(options)
                setFetchMachineGroup(false);
              } 
            }
          } catch (err) {
            console.log(err);
            setFetchMachineGroup(false);
          }
        };
        fetchMachineGroup();
      }, []);

  // Fetch Processes when the component mounts
  const handleLoadData = async () => {

    const p_param = {
      p_end_date_active: endDate,
      p_machine_group_id:machineGroupId.value,
      p_machine_id:machineId.value,
      p_sort_key:sortKey,
      p_start_date_active: startDate
    };
    console.log(p_param);
      try {
        setIsLoading(true);
        const response = await loadApi(p_param,"/api/setup/machineMG/mgMachines/selRows");
        console.log(response);
        console.log("Fetched Machine Names:", response.data);
        console.log(response.data[0]);
        console.log(response.data[1]);
        if (response.data.length > 0) {
          let successFlag = response.data[0];
          if (successFlag === "Y") {
            toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            console.log("success=Y");
            setRows(response.data[1]);
            setIsLoading(false);
            setWasDataFetchingSuccessful(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
            const errorInfo = response.data[2];

            // Set the error message and display the dialog
            setErrorMessage(errorInfo);
            setErrorDialogVisible(true);
            setWasDataFetchingSuccessful(true);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          setWasDataFetchingSuccessful(true);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        console.log("Request was cancelled by the user.");

        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
        console.error("Error fetching Machine Names:", error);
      }
      } finally {
      setIsLoading(false);
    }
    };

  const showProduct = (row) => {
    setRow({ ...row });
    setShowProductDialog(true);
  };
  const openNew = () => {
    setRow(emptyRow);
    setMachineGroupSelectId({label: "", value: null});
    setMachineSelectId({label: "", value: null});
    setSubmitted(false);
    setRowDialog(true);
    setDialog("create")
  };

  const hideDialog = () => {
    setSubmitted(false);
    setRowDialog(false);
    setDialog("")
    setShowProductDialog(false);
    setErrorDialogVisible(false);
  };

  const formatDateColumn = (dateValue) => {
    return dateValue ? moment.utc(dateValue).format("DD-MMM-YYYY") : null;
  };

  const startDateBodyTemplate = (rowData) => {
    return formatDateColumn(rowData.start_date_active);
  };

  const endDateBodyTemplate = (rowData) => {
    return formatDateColumn(rowData.end_date_active);
  };

  /***
        const formatDateFields = (row, isNew) => {
            const formatDate = (date) => date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : null;
    
            return {
                ...row,
                creation_date: isNew ? formatDate(new Date()) : formatDate(row.creation_date),
                last_update_date: formatDate(new Date()),
                start_date: formatDate(row.start_date),
                end_date: formatDate(row.end_date)
            };
        };
         */

  const saveRow = async () => {
    setSubmitted(true);

    if (!row.row_id) {
      //      const isNew = !row.process_id;
      //     const formattedRow = formatDateFields(row, isNew);

      let _rows = [...rows];
      let _row = { ...row };

      try {
        if (row.row_id) {
          /*** Update Row */
          const response = await saveApi(row, "/api/setup/machineMG/mgMachines/updRow");
          //await axios.put(`http://localhost:5000/api/machines/${row.row_id}`, formattedRow);
          //             const updatedRows = rows.map((p) => (p.row_id === row.row_id ? formattedRow : p));
          //             setRows(updatedRows);
          console.log("updating");
          console.log(response.data);
          let successFlag = response.data[0];
          if (successFlag === "Y") {
            const index = findIndexById(row.row_id);
            _rows[index] = _row;
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Machine Updated",
              life: 3000,
              width: "600px",
            });
          } else {
            let err_msg = response.data[1];
            toast.current.show({
              severity: "error",
              summary: err_msg,
              detail: "Machine Name Not Updated",
              life: 3000,
              width: "600px",
            });
          }
        } else {
          /*** Insert Row */
          const response = await saveApi(row, "/api/setup/machineMG/mgMachines/insRow");
          //const response = await axios.post('http://localhost:5000/api/machines', formattedRow);
          //       formattedRow.row_id = response.data.id;
          //     setRows([...rows, formattedRow]);
          console.log("saving");
          console.log("Response data: ", response.data);
          console.log("Response: ", response);
          let successFlag =
            response.data[0]; /** This contains value of Y or N */
          if (successFlag === "Y") {
            _row.row_id =
              response.data[1]; /** It contains newly created Id */
            _rows.push(_row);
            toast.current.show({
              severity: "success",
              summary: (
                <div style={{ marginright: "200px", width: "600px" }}>
                  Success
                </div>
              ),
              detail: <div style={{ width: "600px" }}>Machine Created</div>,
              life: 3000,
              width: "600px",
            });
          } else {
            let err_msg = response.data[2];
            toast.current.show({
              severity: "error",
              summary: <div style={{ width: "600px" }}>{err_msg}</div>,
              detail: <div style={{ width: "600px" }}>{err_msg}</div>,
              life: 3000,
              width: "600px",
            });
          }
        }

        setRows(_rows);
        setRowDialog(false);
        setRow(emptyRow);
      } catch (error) {
        console.error("Error saving Machine Name:", error);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Machine Name Save Failed",
          life: 3000,
          width: "600px",
        });
      }
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Please fill in all required fields",
        life: 3000,
        width: "600px",
      });
    }
  };

  const editRow = (row) => {
    setRow({ ...row });
    setMachineGroupSelectId({label: row.machine_group_name, value: row.machine_group_id});
    setMachineSelectId({label: row.machine_name, value: row.machine_id});
    setRowDialog(true);
    setDialog("edit")
  };

  const findIndexById = (id) => {
    let index = -1;
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].row_id === id) {
        index = i;
        break;
      }
    }
    return index;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const hideDeleteRowDialog = () => {
    setDeleteRowDialog(false);
  };

   const confirmDeleteRow = (row) => {
      setRow(row);
      setDeleteRowDialog(true);
    };
   
     const deleteRow = async () => {
         try {
           const response = await saveApi(row, "/api/setup/machineMG/mgMachines/delRow");
           let successFlag = response.data[0];
           if (successFlag === "Y") {
             let _rows = rows.filter((val) => val.row_id !== row.row_id);
             setRows(_rows);
             setDeleteRowDialog(false);
             setRow(emptyRow);
             toast.current.show({
               severity: "success",
               summary: "Successful",
               detail: "Machine Deleted",
               life: 3000,
               width: "600px",
             });
           } else {
             let err_msg = response.data[1];
             toast.current.show({
               severity: "error",
               summary: err_msg,
               detail: "Machine Not Deleted",
               life: 3000,
               width: "600px",
             });
           }
         } catch (error) {
           console.error("Error deleting Machine :", error);
           toast.current.show({
             severity: "error",
             summary: "Error",
             detail: "Machine Deletion Failed",
             life: 3000,
             width: "600px",
           });
         }
       };
       
       const deleteRowDialogFooter = (
               <React.Fragment>
                 <Button
                   label="No"
                   icon="pi pi-times"
                   className="p-button-text"
                   onClick={hideDeleteRowDialog}
                 />
                 <Button
                   label="Yes"
                   icon="pi pi-check"
                   className="p-button-text"
                   onClick={deleteRow}
                 />
               </React.Fragment>
             );

             const actionBodyDeleteTemplate = (rowData) => {
                       return (
                         <React.Fragment>
                           <Button
                             icon="pi pi-trash"
                             className="p-button-rounded p-button-warning"
                             onClick={() => confirmDeleteRow(rowData)}
                             tooltip="Delete"
                             tooltipOptions={{ position: "bottom" }}
                             disabled={false}
                           />
                         </React.Fragment>
                       );
                     };

  const getLoadingHeaderContents = () => {
    return (
      <React.Fragment>
        <div className="row d-flex justify-content-center m-5">
          <div className="col-auto">
            <div className="card shadow-sm border-primary">
              <div className="card-header bg-primary text-white">
                <h2 className="mb-0">Machine Group - Machine Assignments - Inquire</h2>
              </div>
              <div className="card-body text-center">
                <h3>
                  <i className="fa-duotone fa-fw fa-spin-pulse fa-loader me-3"></i>{" "}
                  The page is loading...
                </h3>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  const getLoadedHeaderContents = () => {
                  return (
                    <React.Fragment>
                      <div className="header-container">
                        <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                        Machine Group - Machine Assignments - Inquire
                        </h2>
                        <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                          <div className="header-container p-1">
                              <style>
                              {`
                                input::placeholder {
                                  font-size: 17px; 
                                }
                              `}
                            </style>
                          {/* <span className="p-input-icon-right w-full md:w-auto"> 
                        <InputText
                          type="search"
                          onInput={(e) => setGlobalFilter(e.target.value)}
                          placeholder="Search..."
                          className="w-full lg:w-auto text-sm p-3"
                          style={{ fontSize: '17px' }} 
                        />
                      </span> */}
                          </div>
                        </h2>
                      </div>
                    </React.Fragment>
                  );
                }


  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _row = { ...row };
    _row[`${name}`] = val;

    setRow(_row);
  };

  const onInputMachineSelectChange = (selectedOption, name, id) => {
    if(selectedOption == null) {
      setMachineSelectId({label: "", value: null});
    } else {
    setMachineSelectId(selectedOption);
    }
    const val = selectedOption != null ? selectedOption.value : null;
    const val1 = selectedOption != null ? selectedOption.label : "";

    let _row = { ...row };
    _row[`${id}`] = val;
    _row[`${name}`] = val1;

    setRow(_row);
  };

  const onInputMachineGroupSelectChange = (selectedOption, name, id) => {
    if(selectedOption == null) {
      setMachineGroupSelectId({label: "", value: null});
    } else {
    setMachineGroupSelectId(selectedOption);
    }
    const val = selectedOption != null ? selectedOption.value : null;
    const val1 = selectedOption != null ? selectedOption.label :"";

    let _row = { ...row };
    _row[`${id}`] = val;
    _row[`${name}`] = val1;

    setRow(_row);
  };

  const onInputNumberChange = (e, name) => {
    const val = (e.target.valueAsNumber) || "";
    let _row = { ...row };
    _row[`${name}`] = val;

    setRow(_row);
  };

  /***
    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="New" icon="pi pi-plus" className="p-button-success p-mr-2" onClick={openNew} />
            </React.Fragment>
        )
    }

    const headerDontUse = (
        <div className="table-header">
            <h5 className="p-m-0">Manage Machines</h5>
            {/* <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
            </span> * /}
        </div>
    );
    */

  const header = (
    <div
      className="table-header"
      style={{
        display: "flex",
        justifyContent: "space-between",
        height: "3rem",
        alignContent: "center",
      }}
    >
      <div
        style={{
          width: window.innerWidth / 3,
          display: "flex",
          justifyContent: "flex-start",
          marginRight: "110px",
        }}
      >
        <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span>
      </div>
      <div>
        <Button
          // label="New"
          icon="pi pi-plus"
          className="p-button-rounded p-button-success p-mr-2"
          onClick={openNew}
          tooltip="New"
          tooltipOptions={{ position: "bottom" }}
        />
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
          style={{ marginLeft: "20px" }}
        />
      </div>
    </div>
  );

  const actionBodyEditTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-success p-mr-2"
          onClick={() => editRow(rowData)}
          tooltip="Edit"
          tooltipOptions={{ position: "bottom" }}
          // disabled={true}
        />
      </React.Fragment>
    );
  };

  const sDate = row.start_date_active ? moment.utc(row.start_date_active).format("DD-MMM-YYYY") : null;
  const eDate = row.end_date_active ? moment.utc(row.end_date_active).format("DD-MMM-YYYY") : null;

  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

     const CardComponent = ({title, data}) => {
      const rightAlignedLabels = ["Sort Key : "];
    
          return (
            <Card className="card-containers">
              <h5  style={{"fontWeight":"bold"}}> {title} </h5>
              <Divider className="my-2" />
              {data.map((item, index) => (
                <div key={index} className="label-value-pair">
                  <span className="label">{item.label}</span>
                  
                  {item.label &&
                  <span         
                  className={`value-box ${rightAlignedLabels.includes(item.label) ? "align-right": ""}`}>
                    {item.value}</span>
                  }
                  
                </div>
              ))}
            </Card>
          )
        }
  
  const inputRightBoxStyle = {
    textAlign: "right",
     outline: "0.015625rem thin #d3d3d3",
    borderradius: "5px", 
    border: "thin solid #d3d3d3",
    paddingLeft: "6px",
    borderRadius: "4px",
    backgroundColor:"rgb(235, 235, 235)",
    width: "100%",
  }
  const inputDateStyle = {
    outline: "0.015625rem thin #d3d3d3",
    borderradius: "5px", 
    border: "thin solid #d3d3d3",
    paddingLeft: "6px",
    borderRadius: "4px",
    backgroundColor:"rgb(235, 235, 235)",
    width: "100%",
  }
  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    return `${year}-${month}-${day}`
  }

  const handleMachineIdChange = (selectedOption) => {
    if(selectedOption == null) {
      setMachineId({label: "", value: null});
    } else {
    setMachineId(selectedOption);
    }
  }

  const handleMachineGroupChange = (selectedOption) => {
    if(selectedOption == null) {
      setMachineGroupId({label: "", value: null});
    } else {
    setMachineGroupId(selectedOption);
    }
  }

     const getMachineIdControl = () => (
        <React.Fragment>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">Machine Name</label>
         <Select
            // className="form-select"
            id="machineId"
            name="machineName"
            onChange={handleMachineIdChange}
            options={machineName}
            value={machineId}
            placeholder="Select Machine"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            className="select-dropdown"
            classNamePrefix="select-dropdown"
          />
      </div>
    </React.Fragment>
      );

      const getMachineGroupIdControl = () => (
        <React.Fragment>
      <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
        <label className="form-label">Machine Group Name</label>
         <Select
            // className="form-select"
            id="machineGroupId"
            name="machineGroupId"
            onChange={handleMachineGroupChange}
            options={machineGroup}
            value={machineGroupId}
            placeholder="Select Machine Group"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            className="select-dropdown"
            classNamePrefix="select-dropdown"
          />
      </div>
    </React.Fragment>
      );

      const getSortKeyControl = () => (
        <React.Fragment>
          <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
            <label className="form-label">Sort Key</label>
           <input
           type="number"
           value={sortKey}
           onChange={(e) => setSortKey(e.target.valueAsNumber)}
           className="input-outline"
           />
          </div>
        </React.Fragment>
      );

      const getStartEndDateControls = () => (
          <React.Fragment>
            <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
              <label className="form-label">Start Date Active</label>
              <div className="input-group date input-wrapper">
              <input
                type="date"
                id="StartDate"
                name="StartDate"
                value={startDate}
                onChange={handleStartDateChange}
                disabled={isLoading}
                className="input-outline1"
              />
              </div>
            </div>
            <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
              <label className="form-label">End Date Active</label>
              <div className="input-group date input-wrapper">
              <input
                type="date"
                id="EndDate"
                name="EndDate"
                value={endDate}
                onChange={handleEndDateChange}
                disabled={isLoading}
                className="input-outline1"
              />
              </div>
            </div>
          </React.Fragment>
        );
      
        const handleStartDateChange = (e) => {
          setStartDate(e.target.value);
        };
      
        const handleEndDateChange = (e) => {
          setEndDate(e.target.value);
        };

     const getGoButtonControl = () => (
        <React.Fragment>
          <div className="col-auto d-flex align-items-center justify-content-center ps-2 pe-0" style={{paddingTop:'1.9375rem'}}>
            <button
              type="button"
              className="btn btn-primary load-button"
              id={"chartAreaId"}
              onClick={handleLoadData}
              disabled={isLoading}
            >
               <i
                className={
                  isLoading ? "fa-duotone fa-fw fa-rotate fa-spin" : "fa-duotone fa-fw fa-rotate"
                }
              ></i>
              <span>{isLoading ? "Loading" : "Go"}</span>
            </button>
          </div>
        </React.Fragment>
      );
  return (
    <div>
      <Toast ref={toast} />
    <div className="col mx-2">
        {fetchMachine && fetchMachineGroup ? getLoadingHeaderContents() : getLoadedHeaderContents()}
        {!fetchMachine && !fetchMachineGroup && (
        <div className="row">
          <div className="col">
            <div className="row justify-content-center">
              {getMachineIdControl()}
              {getMachineGroupIdControl()}
              {getSortKeyControl()}
              {getStartEndDateControls()}
              {getGoButtonControl()}
            </div>
            {!wasDataFetchingSuccessful && (
              <div className="card my-3">
            {/* <div className="text-3xl text-800 font-bold mb-4">Inquire NonWork Type</div> */}
            <DataTable
              ref={dt}
              value={rows}
              selection={selectedRows}
              onSelectionChange={(e) => setSelectedRows(e.value)}
              dataKey="row_id"
              scrollable
              scrollHeight="flex"
              className="custom-datatable-border"
              tableStyle={{ minWidth: "50rem" }}
              paginator
              rows={pecaPageRows}
              rowsPerPageOptions={pecaRowsPerPageOptions}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Machine"
              globalFilter={globalFilter}
              header={header}
              emptyMessage="No Machine found"
              stripedRows
              showGridlines        
              responsiveLayout="scroll"
              rowExpansion
            >
              {/* <Column
                body={drillDownTemplate}
                style={{ width: "0.75rem", textAlign: "center" }}
              /> */}
              <Column
                body={readBodyTemplate}
                exportable={false}
                style={{ width: "0.75rem" }}
              ></Column>
              <Column
                field="row_id"
                header="id"
                sortable="false"
                hidden="true"
                exportable={false}
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="machine_name"
                header="Machine Name"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="machine_group_name"
                header="Machine Group Name"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="sort_key"
                header="Sort Key"
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="start_date_active"
                header="Active Start Date"
                body={startDateBodyTemplate}
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                field="end_date_active"
                header="Active End Date"
                body={endDateBodyTemplate}
                sortable
                style={{ whiteSpace: "nowrap" }}
              ></Column>
              <Column
                body={actionBodyEditTemplate}
                style={{ width: "0.75rem" }}
              ></Column>
              <Column
              body={actionBodyDeleteTemplate}
              style={{ width: "0.75rem" }}
              ></Column>
            </DataTable>
          </div>
        )}
        </div>
        </div>
        )}
        <Dialog
          visible={rowDialog}
          style={{ width: "1400px" }}
          modal
          className="p-fluid"
          onHide={hideDialog}
        >
          <h4 style={{"fontWeight":"bold"}}> Machine Group - Machine Assignments - Inquire </h4>
          <Divider className="my-4" />
          <h5 style={{"fontWeight":"bold"}}>  {dialog === "edit" ? "Update Machine Name" : dialog === "create" ? "Create New Machine Name Information" : ""} </h5>
          <Divider className="my-4" />
          <div className="card-wrapper">
          <Card className="card-containers">
            <h5  style={{"fontWeight":"bold"}}> Machine Name Details </h5>
            <Divider className="my-2" />
            <div className="label-value-pair">
            <span className="label" htmlFor="machine_group_id">Machine Group Name : </span>
            <span style={{flexGrow:1}}>
              <Select
            // className="form-select"
            id="machineGroupSelectId"
            name="machineGroupSelectId"
            onChange={(selectedOption) => onInputMachineGroupSelectChange(selectedOption, "machine_group_name", "machine_group_id")}
            options={machineGroup}
            value={machineGroupSelectId}
            placeholder="Select Machine Group"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            lassName="select-dropdown2"
            classNamePrefix="select-dropdown2"
          />
            </span>
            {submitted && row.machine_group_id == null && dialog === "create" && (
              <small className="p-error">Machine Group Name is required.</small>
            )}
          </div>

            <div className="label-value-pair">
            <span className="label" htmlFor="machine_id">Machine Name : </span>
            <span style={{flexGrow:1}}>
            <Select
            // className="form-select"
            id="machineSelectId"
            name="machineSelectId"
            onChange={(selectedOption) => onInputMachineSelectChange(selectedOption, "machine_name", "machine_id")}
            options={machineName}
            value={machineSelectId}
            placeholder="Select Machine"
            isSearchable={true}
            isClearable={true}
            isDisabled={isLoading}
            lassName="select-dropdown2"
            classNamePrefix="select-dropdown2"
          />
            </span>
            {submitted && row.machine_id == null && dialog === "create" && (
              <small className="p-error">Machine Name is required.</small>
            )}
          </div>

          <div className="label-value-pair">
            <span className="label"htmlFor="sort_key">Sort Key : </span>
            <span style={{flexGrow:1}}>
           <input
           type="number"
           value={row.sort_key}
           onChange={(e) => onInputNumberChange(e, "sort_key")}
           style={inputRightBoxStyle}
           />
            </span>
          </div>
          </Card>
          <Card className="card-containers">
            <h5  style={{"fontWeight":"bold"}}> Active Dates </h5>
            <Divider className="my-2" />
            <div className="label-value-pair">
            <span className="label" htmlFor="start_date_active">Active Start Date : </span>
            <span style={{flexGrow:1}} className="input-wrapper">
            <input
              type="date"
              id="start_date_active"
              defaultValue={formatDateTime(row.start_date_active)}
              onChange={(e) => onInputChange(e, "start_date_active")}
              style={inputDateStyle}
            />
            </span>
          </div>
          <div className="label-value-pair">
            <span className="label" htmlFor="end_date_active">Active End Date : </span>
            <span style={{flexGrow:1}} className="input-wrapper">
            <input
              type="date"
              id="end_date_active"
              defaultValue={formatDateTime(row.end_date_active)}
              onChange={(e) => onInputChange(e, "end_date_active")}
              style={inputDateStyle}
            />
            </span>
          </div>
          </Card>
          </div>
          <div className="btn-container">
          <Button
            label="Cancel"
            icon="pi pi-times"
            className="p-button-text"
            onClick={hideDialog}
            style={{"width":"20%","backgroundColor":"#0d6efd", "color":"white", "borderRadius":"4px", "cursor":"pointer"}}
          />
          <Button
            label="Save"
            icon="pi pi-check"
            className="p-button-text"
            onClick={saveRow}
            style={{"width":"20%","backgroundColor":"#0d6efd", "color":"white", "borderRadius":"4px", "cursor":"pointer"}}
          />
          </div>
        </Dialog>
          
       <Dialog visible={showproductDialog} style={{ width: '1400px' }} modal className="p-fluid" onHide={hideDialog}>     
                        <h4 style={{"fontWeight":"bold"}}> Machine Group - Machine Assignments - Inquire </h4>
                        <Divider className="my-4" />
                        <h5 style={{"fontWeight":"bold"}}> View Machine Name Information </h5>
                        <Divider className="my-4" />
                        <div className="card-wrapper">
                          <CardComponent
                            title="Machine Name Details"
                            data={[
                              {label:"Machine Group Name : ", value: row.machine_group_name },
                              {label:"Machine Name : ", value: row.machine_name },
                              {label:"Sort Key : ", value: row.sort_key},
                            ]}
                          />
                          <CardComponent
                            title="Active Dates"
                            data={[
                              {label:"Active Start Date : ", value: sDate },
                              {label:"Active End Date : ", value: eDate },
                            ]}
                          />
                         </div>
                    </Dialog>
                    <Dialog
                              visible={deleteRowDialog}
                              style={{ width: "450px" }}
                              header="Confirm"
                              modal
                              footer={deleteRowDialogFooter}
                              onHide={hideDeleteRowDialog}
                            >
                              <div className="confirmation-content">
                                <i
                                  className="pi pi-exclamation-triangle p-mr-3"
                                  style={{ fontSize: "1.5rem", paddingRight: "10px" }}
                                />
                                {row && (
                                  <span>
                                    Are you sure you want to delete <b>{row.use_lot_type}</b>?
                                  </span>
                                )}
                              </div>
                            </Dialog>
                    <Dialog 
                        header="API Error" 
                        visible={errorDialogVisible} 
                        style={{ width: '400px' }} 
                        onHide={hideDialog} 
                        footer={
                            <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                        }
                    >    
                     <p>
        
                            {errorMessage}
                        </p>
                    </Dialog>
                    <style jsx>{`
                      .card-wrapper {
                        display: grid;
                        grid-template-columns: repeat(2,1fr);
                        gap: 10px;
                        padding: 5px;
                      }
        
                      .card-containers {
                        display: flex;
                        background-color: #f9f9f9;
                        flex-direction: column;
                        justify-content: flex-start;
                        border: 1px solid #ccc;
                        paddig: 10px;
                        box-shadow: 4px 4px 10px rgba(0,0,0,0.2);
                        height: auto;
                        width: 100%;
                      }
        
                      .label-value-pair {
                        display: flex;
                        flex-direction: row,
                        align-items: flex-start;
                        gap: 5px;
                        margin-bottom: 8px;
                        flex-wrap: wrap;
                      }
        
                      .label {
                        font-weight: bold;
                        white-space: nowrap;
                      }
        
                      .value-box {
                        background-color:rgb(235, 235, 235);
                        padding: 6px 10px;
                        border-radius: 4px;
                        display: block;
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        flex-grow: 1;
                        min-width: 0;
                      }

                      .align-right {
                        text-align: right;
                        background-color:rgb(235, 235, 235);
                        padding: 6px 10px;
                        border-radius: 4px;
                        display: block;
                        word-wrap: break-word;
                        overflow-wrap: break-word;
                        flex-grow: 1;
                        min-width: 0;
                      }

                      .btn-container {
                      display: flex;
                      justify-content: center;
                      gap:20px;
                      margin-top:20px;
                      }
                    `}
                    </style>
                    </div>
    </div>
  );
};

export default MgMachine;
